export default {
    partnumber_tab_label: "Part Number",
    partnumber_tab_device_model: "Device Model",
    partnumber_tab_network: "Network",
    partnumber_tab_created_at: "Created At",
    partnumber_tab_created_by: "Create By",
    partnumber_tab_add_new: "Add New",
}